

export default class Messager {

    alert(msg) {
        alert(msg);
    }

    async confirm(msg) {
        return confirm(msg);
    }
}


// WEBPACK FOOTER //
// ./src/stores/messager.ts